import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useCtxReferences } from "utils/selectors";
import { useAppRouteMetadatas } from "utils/selectors";
import { createMetadata } from "actions/metadata";
import MetadataEdit from "components/MetadataForm/Edit";
import SectionBezel from "components/SectionBezel";
import { getLiveRouteManifest } from "utils/mapStateToProps";
import Pill from "components/Pill";
import { PILL_THEME } from "components/Pill";
import Button from "components/Form/fields/Button";
import { STATUS, UI_THEME } from "utils/constants/ui";
import { buildMetadataData } from "utils/metadata";
import SlimCTA from "components/SlimCTA";
import { formFactorAction } from "utils/view";
import { getUUID } from "utils/uuid";

const DEFAULT_INFO = {
  icon: "globe",
  copy:
    "Preview how your page will look when shared in social channels. The metadata image will be inherited from content on your page."
};

const NO_MANIFEST_INFO = {
  icon: "alert",
  copy:
    "No page published to this route. When this route is live, the metadata image will be inherited from content on your page."
};

const MetadataBezel = ({ actions, route }) => {
  const [loading, setLoading] = useState(false);
  const {
    resource,
    resourceUUID,
    application,
    merchantAccount
  } = useCtxReferences();
  const metadatas = useAppRouteMetadatas();
  const metadata = metadatas.find((metadata) => metadata.route === route);
  const manifest = getLiveRouteManifest({
    route,
    application
  });

  const createRouteMetadata = () => {
    setLoading(true);

    const newMetadataParams = {
      uuid: getUUID(),
      route,
      application_id: application.id,
      data: buildMetadataData({
        merchantAccount
      })
    };

    actions.createMetadata(
      {
        resource,
        resourceUUID,
        data: newMetadataParams
      },
      () => {
        setLoading(false);
      }
    );
  };
  let innerContent = null;
  let sectionAction;
  if (metadata) {
    innerContent = (
      <MetadataEdit
        key={metadata.id}
        metadata={metadata}
        manifest={manifest}
        info={manifest ? DEFAULT_INFO : NO_MANIFEST_INFO}
      />
    );
    sectionAction = manifest ? (
      <Pill theme={PILL_THEME.SLIM} status={STATUS.SUCCESS} copy="Live" />
    ) : null;
  } else {
    innerContent = (
      <SlimCTA
        subheader={`No metadata for ${route}. ${formFactorAction()} create to get started.`}
      />
    );
    sectionAction = (
      <Button
        theme={UI_THEME.SLIM}
        loading={loading}
        onClick={createRouteMetadata}
        copy="Create"
      />
    );
  }

  return (
    <SectionBezel header={route} expandable={metadata} action={sectionAction}>
      {innerContent}
    </SectionBezel>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createMetadata
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(MetadataBezel);
